export const age_order = [
  '0-4',
  '5-9',
  '10-14',
  '15-19',
  '20-24',
  '25-29',
  '30-34',
  '35-39',
  '40-44',
  '45-49',
  '50-54',
  '55-59',
  '60-64',
  '65-69',
  '70-74',
  '75-79',
  '80-84',
  '85+',
];

export const year_order = [
  '2008',
  '2009',
  '2010',
  '2011',
  '2012',
  '2013',
  '2014',
  '2015',
  '2016',
  '2017',
  '2018',
  '2019',
  '2020',
  '2021',
  '2022',
  '2023',
  '2024',
  '2025',
];

export const quarter_order = [1, 2, 3, 4];

export const activity_order = [
  'водоснабжение; сбор, обработка и удаление отходов, деятельность по ликвидации загрязнений',
  'горнодобывающая промышленность и разработка карьеров',
  'государственное управление и оборона; обязательное социальное обеспечение',
  'деятельность в области административного и вспомогательного обслуживания',
  'деятельность домашних хозяйств, нанимающих домашнюю прислугу и производящих товары и услуги для собственного потребления ',
  'деятельность экстерриториальных организаций и органов',
  'здравоохранение и социальное обслуживание населения',
  'информация и связь',
  'искусство, развлечения и отдых',
  'обрабатывающая промышленность',
  'образование',
  'операции с недвижимым имуществом',
  'оптовая и розничная торговля; ремонт автомобилей и мотоциклов',
  'предоставление прочих видов услуг',
  'предоставление услуг по проживанию и питанию',
  'промышленность',
  'профессиональная, научная и техническая деятельность',
  'сельское, лесное и рыбное хозяйство',
  'снабжение электроэнергией, газом, паром, горячей водой и  кондиционированным воздухом',
  'строительство',
  'транспорт и складирование',
  'финансовая и страховая деятельность',
];

export const salary_age_order = [
  '16-24 года',
  '25-34 лет',
  '35-44 лет',
  '45-54 лет',
  '55-64 года',
  '65 лет и старше',
];
